import React from 'react';
import styles from '../Styles/EventOps.module.css';
import { CHANNELS, CHANNEL_LABEL } from './placeholders';

/** 📱 💬 ✉ checkboxes. `value` is the selected channels; `onChange` gets the
 * new list in push/sms/email order. `allowed` limits which render. */
export default function ChannelPicker({ value = [], onChange, allowed = CHANNELS }) {
  const selected = new Set(value);
  const toggle = (ch, on) => {
    const next = new Set(selected);
    if (on) next.add(ch);
    else next.delete(ch);
    onChange?.(CHANNELS.filter((c) => next.has(c)));
  };
  return (
    <div className={styles.channelRow}>
      {CHANNELS.filter((c) => allowed.includes(c)).map((ch) => (
        <label key={ch} className={styles.channelOption}>
          <input type="checkbox" checked={selected.has(ch)} onChange={(e) => toggle(ch, e.target.checked)} />
          {CHANNEL_LABEL[ch]}
        </label>
      ))}
    </div>
  );
}
